import { useLocation, type Location as RouterLocation } from "react-router-dom";

export const useTypedLocation = <T>() => {
  const { state, ...restProps } = useLocation();
  return { state: state as T, ...restProps } as RouterLocation;
};
